import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';

const styles = makeStyles((theme: Theme) => ({
  divider: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: 0,
    width: '100%',
  },
}));

export const Divider: React.FC = () => {
  const classes = styles();
  return <div className={classes.divider}></div>;
};
